import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GraphService {
  constructor(private http: HttpClient) {}

  getProfile() {
    return this.http.get('https://graph.microsoft.com/v1.0/me');
  }
}
